export const fetchGetTopProducts = (parentId: number) =>
  fetch(`/api/v1/top/products?parentId=${parentId}`).then((res) => res.json())
